import { Directive, HostListener, ElementRef } from '@angular/core';
import { ToastService } from '../services/toast.service';

@Directive({
  selector: '[alphabetOnly]'
})
export class AlphabetOnlyDirective {

  // Regular expression to allow only alphabets (uppercase, lowercase) and spaces
  // private regexNew: RegExp = /^[a-zA-Z\s]+$/;
  private regexNew: RegExp = /[!@#$%^&*(),.?":{}|<>]/;
  private regex: RegExp = /^[a-zA-Z]+$/;
  private space : RegExp = /\s+/g;
  private maxLength: number = 50;
  // Regular expression to detect emojis (using Unicode ranges for common emojis)
  private emojiRegex: RegExp = /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{2B50}-\u{2B55}|\u{23F0}-\u{23F3}|\u{2B06}-\u{2B07}|\u{2B05}-\u{2B07}]/u;

  constructor(private el: ElementRef,private toasterService: ToastService) { }
  // Keypress handler to restrict input to alphabets and spaces, prevent emoji input
  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const key = event.key;

    // Prevent the default action if the key doesn't match the allowed alphabet pattern or is an emoji
    if (!this.regex.test(key) || this.emojiRegex.test(key)) {
      event.preventDefault();
      this.toasterService.show(`Only Alphabets are allowed!`, {
        class: 'danger',
        title: 'Alert',
    });
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    // Get the pasted data from the clipboard
    let clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedText = clipboardData.getData('text');
    console.log(pastedText);
    if (pastedText.length >= this.maxLength) {
      event.preventDefault();
      this.toasterService.show('Maximum character limit of 50 reached.', {
        class: 'danger',
        title: 'Input Limit Reached'
      });
      return;
    }
        // Check if the pasted text contains only allowed characters
        if (this.regexNew.test(pastedText) || this.emojiRegex.test(pastedText) || this.space.test(pastedText)) {
          // Both special characters and emojis detected
          this.toasterService.show(`Only Alphabets are allowed!`, {
              class: 'danger',
              title: 'Alert',
          });
      } 
      
  }

  // Input handler to detect any input method (including emoji keyboard) and block invalid content
  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let currentValue = inputElement.value;

    // Remove any emojis or invalid characters from the input field
    const sanitizedValue = currentValue.replace(/[^a-zA-Z\s]+/g, '').replace(this.emojiRegex, '').replace(/\s+/g, '');

    // Update the input field with the sanitized value
    if (sanitizedValue !== currentValue) {
      inputElement.value = sanitizedValue;
    }
  }
}
